import DOMPurify from "dompurify";

// Every string rendered with {@html} must pass through here. Message content
// comes from the bot, live agents, the user, and URL-derived values (city /
// property slugs), so none of it can be trusted as markup.
const purifier = DOMPurify();

purifier.addHook("afterSanitizeAttributes", (node) => {
  if (node.tagName === "A" && node.getAttribute("target") === "_blank") {
    node.setAttribute("rel", "noopener noreferrer");
  }
});

export const sanitizeHtml = (html: string): string =>
  purifier.sanitize(html, {
    USE_PROFILES: { html: true },
    ADD_ATTR: ["target"],
    FORBID_TAGS: ["style", "form", "input", "button", "textarea", "select"],
  }) as string;
